import axios from 'axios';
import router from '../router'
import { EventBus } from '../main'
import Vue from 'vue'
import store from '../store'

export default {
    data: {
        config: {},
        TYPE_INVOICE: 'SALE_INVOICE'
    },
    methods: {
        /*
        * GET NEXT RUNNING NUMBER
        */
        async getNextNo (companyId) {
            this.config = {
                params: {
                    business_id : companyId
                }
            };
            EventBus.$emit('show-loading', true);
            return await axios
                .get('/sales/invoices/next_no', this.config)
                .then(response => {
                    EventBus.$emit('show-loading', false);
                    store.dispatch('invoice/setCreateInvoiceObj', { no: response.data.next_no})
                })
                .catch(error => {
                    EventBus.$emit('show-loading', false);
                    Vue.prototype.$generalAPIErrorHandling(error, router);
                })
        },

        /*
        * POST INVOICE
        */
        async postInvoice(data){
            EventBus.$emit('show-loading', true);
            return await axios
                .post('/sales/invoices', data, this.config)
                .then(response => {
                    EventBus.$emit('show-loading', false);
                    Vue.prototype.$successToast('Invoice successfully created.');
                    store.dispatch('invoice/clearCreateInvoiceData');
                    router.push('invoices/all');
                })
                .catch(error => {
                    EventBus.$emit('show-loading', false);
                    Vue.prototype.$generalAPIErrorHandling(error, router);
                })

        },

        /*
        * GET ALL INVOICES
        */
        async getInvoices(companyId){
            this.config = {
                params: {
                    entity_id: companyId,
                    type: "SALE_INVOICE"

                }
            };
            EventBus.$emit('show-loading', true);
            return await axios
                .get('/sales', this.config)
                .then(response => {
                    EventBus.$emit('show-loading', false);
                    return response.data
                })
                .catch(error => {
                    EventBus.$emit('show-loading', false);
                    Vue.prototype.$generalAPIErrorHandling(error, router);
                })

        }



    }
}
